export default class Licence {
  
  constructor () {
    this.getParam()
    this.init()
  }

  getParam() {

    // layoutChange
    this.layout = document.querySelector(`[data-module="licence"]`)
    this.layout01Toggle = document.getElementsByClassName('is-layout-01')[0]
    this.layout02Toggle = document.getElementsByClassName('is-layout-02')[0]
    this.overviewNormal = document.querySelector(`[data-module="overview-normal"]`)
    this.overviewSquare = document.querySelector(`[data-module="overview-square"]`)
    this.layoutClassNormal = 'is-normal'
    this.layoutClassSquare = 'is-square'
    this.toggleCLass = 'is-active'

    // selectShow

    this.selectItem = document.querySelectorAll(`[data-module="select-hover"]`)
    this.ArraySelectItem = Array.prototype.slice.call(this.selectItem)

  }

  init () {
    this.layoutChange()
    this.selectShow()
  }

  layoutChange () {
    if( this.overviewSquare) {
      this.overviewSquare.style.display = 'none';
    }

    var mql = window.matchMedia('(max-width:767px)');


    this.layout01Toggle.addEventListener('click', ()=> {
      this.layout.classList.add(this.layoutClassNormal)
      this.layout.classList.remove(this.layoutClassSquare)
      this.layout01Toggle.classList.add(this.toggleCLass)
      this.layout02Toggle.classList.remove(this.toggleCLass)
      const Event= (e)=> {
        if (e.matches) {
          this.overviewNormal.style.display = 'none'
          this.overviewSquare.style.display = 'none'          
          /* the viewport is 600 pixels wide or less */
        } else {
          if( this.overviewSquare) {
            this.overviewNormal.style.display = 'block'
            this.overviewSquare.style.display = 'none'
          }          
          /* the viewport is more than than 600 pixels wide */
        }
      }
      
      mql.addListener(Event);
      Event(mql)          
    })

    this.layout02Toggle.addEventListener('click', ()=> {
      this.layout.classList.remove(this.layoutClassNormal)
      this.layout.classList.add(this.layoutClassSquare)
      this.layout01Toggle.classList.remove(this.toggleCLass)
      this.layout02Toggle.classList.add(this.toggleCLass)
      const Event= (e)=> {
        if (e.matches) {
          this.overviewNormal.style.display = 'none'
          this.overviewSquare.style.display = 'none'          
          /* the viewport is 600 pixels wide or less */
        } else {
          if( this.overviewSquare) {
            this.overviewSquare.style.display = 'block';
            this.overviewNormal.style.display = 'none'
          }   
          /* the viewport is more than than 600 pixels wide */
        }
      }
      
      mql.addListener(Event);
      Event(mql)         
    })
  }

  selectShow() {

    var mql = window.matchMedia('(max-width:767px)');

    const Event=(e)=> {

      Array.prototype.forEach.call(this.ArraySelectItem,(elem)=> {
        const
          toggle = elem.getElementsByClassName('current-text')[0],
          selectBoxItem = elem.querySelectorAll('.select-list')[0],
          selectBox = elem.querySelectorAll('.select-list > li > label'),
          ArrayselectBox = Array.prototype.slice.call(selectBox)
  
  
        Array.prototype.forEach.call(ArrayselectBox, (el) => {
          const Listelem = el.textContent
  
          el.addEventListener('click' ,()=> {
            toggle.innerText = Listelem;         
  
            selectBoxItem.classList.remove('is-show')
          })
        })
      })
  
      if (e.matches) {
        Array.prototype.forEach.call(this.ArraySelectItem,(elem)=> {
          const
            toggle = elem.getElementsByClassName('current-text')[0],
            selectBoxItem = elem.querySelectorAll('.select-list')[0],
            selectBox = elem.querySelectorAll('.select-list > li > label')
          toggle.addEventListener('click',()=> {
            selectBoxItem.classList.add('is-show')
          })
    
        selectBoxItem.addEventListener('click',()=> {
          selectBoxItem.classList.remove('is-show')
        })
      })

        /* the viewport is 600 pixels wide or less */
      } else {

        Array.prototype.forEach.call(this.ArraySelectItem,(elem)=> {
          const
            toggle = elem.getElementsByClassName('current-text')[0],
            selectBoxItem = elem.querySelectorAll('.select-list')[0],
            selectBox = elem.querySelectorAll('.select-list > li > label')
          toggle.addEventListener('mouseenter',()=> {
            selectBoxItem.classList.add('is-show')
          })
    
          selectBoxItem.addEventListener('mouseleave',()=> {
            selectBoxItem.classList.remove('is-show')
          })

        })
        /* the viewport is more than than 600 pixels wide */
      }
    }
    
    mql.addListener(Event);
    Event(mql)    

  }
}